/* import __COLOCATED_TEMPLATE__ from './back.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './back.module.scss';

@classic
@classNames(styles.component)
export default class SignInBack extends Component {}
